import EditableCustomCheckBox from 'Global/Components/EditableComponents/EditableCustomCheckBox.js/EditableCustomCheckBox';
import React from 'react';
import useMatchCheckLang from '../useMatchCheckLang/useMatchCheckLang';

const CheckPrefrences = ({ field, onChange }) => {
  const label = useMatchCheckLang(field);

  return (
    <React.Fragment>
      <div dir="rtl">
        <EditableCustomCheckBox
          defaultChecked={field.Value === 'True'}
          size="1.3em"
          label={label}
          onChange={(val) => {
            if (val) {
              onChange('True');
            } else {
              onChange('False');
            }
          }}
          BooleanOutPut
        />
      </div>
    </React.Fragment>
  );
};

export default CheckPrefrences;
